import React from 'react';
import './notFound.css';

const NotFound = () => {
  return (
    <div className="notfound">
      <h2 className="h2 notfound__title">Ошибка 404</h2>
      <p className="notfound__text">Такой страницы не существует</p>
    </div>
  );
};

export default NotFound;
